import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const MailInboxesRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings', 'role--settings--mail-inboxes']}>
    <Route index element={<Index />} />
  </SubRouter>
))
